import React, { Component } from "react";
import { connect } from "react-redux";
import { DeviceInfoDialog } from "../dialogs/DeviceInfoDialog";
import { fetchInstalledApps } from "../redux/actions/dataActions";
import { getDeviceApprovedApps } from "../utils/deviceDialogUtils";

export class DeviceInfo extends Component {

  componentDidMount() {
    this.props.fetchInstalledApps(this.props.deviceKey);
  } 

  render() {
    const {
      deviceKey,
      devices,
      deviceGroups,
      installedApps,
      apps,
      contentBundles,
      onClose,
      onEdit,
      onDeviceComandsClick
    } = this.props;
    const device = devices[deviceKey];
    if(!device)return(<div/>);
    const deviceGroup = device.deviceGroupRef
      ? deviceGroups[device.deviceGroupRef.id]
      : "";
    if(!deviceGroup)return(<div/>); 
    const approvedApps = getDeviceApprovedApps({
      deviceGroup,
      apps,
      contentBundles
    });
    
    return (
        <DeviceInfoDialog
          onClose={onClose}
          onEdit={onEdit}
          device={device}
          deviceGroup={deviceGroup}
          approvedApps={approvedApps}
          installedApps={installedApps}
          onDeviceComandsClick={()=>onDeviceComandsClick({deviceKeys:[deviceKey], deviceGroupKey:device.deviceGroupRef.id, forGroup:false, title:device.name})}
        />
    );
  }
}

const mapStateToProps = state => {
  return {
    devices: state.data.devices,
    deviceGroups: state.data.deviceGroups,
    installedApps: state.data.installedApps,
    apps: state.data.apps,
    contentBundles: state.data.contentBundles,
    currentUser: state.user.user
  };
};

const mapDispatchToProps = { fetchInstalledApps };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeviceInfo);
